import { Injectable, NgZone } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class IdleService {
  private idleTimeout: any;
  private idleTime = 60000; // TEST: 10 detik, nanti bisa diganti 60000 (1 menit)
  public onIdle$ = new Subject<boolean>();

  constructor(private ngZone: NgZone) {
    this.initListener();
  }

  private initListener() {
    ['mousemove', 'keydown', 'click', 'touchstart'].forEach(event => {
      window.addEventListener(event, () => this.userActive());
    });
    this.resetTimer();
  }

  private resetTimer() {
    clearTimeout(this.idleTimeout);
    this.idleTimeout = setTimeout(() => {
      this.ngZone.run(() => this.onIdle$.next(true)); // masuk idle
    }, this.idleTime);
  }

  private userActive() {
    this.resetTimer();
    this.ngZone.run(() => this.onIdle$.next(false)); // kembali aktif
  }
}
